"use client";
import Image from "next/image";
import { useMemo, useState } from "react";
import "./PopularDestinationWidget.css";
import { useIntl } from "react-intl";
import Link from "next/link";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsDestination } from "../../../Orchestrator/Types/Interface/ICmsDestination";
import CommonCardSlider from "../../CommonCardSlider/CommonCardSlider";
import SectionCardSkeleton from "../../Shared/SectionCardSkeleton/SectionCardSkeleton";
import { useOnLanguageChange } from "../../CustomHooks/useOnLanguageChange";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";

interface PopularDestinationWidgetProps {
  title?: string;
  filterId?: string;
  subtitle?: string;
}

const PopularDestinationWidget = ({
  title,
  filterId,
  subtitle,
}: PopularDestinationWidgetProps) => {
  const intl = useIntl();
  const [loading, setLoading] = useState<Boolean>(false);

  const [destinations] = useRecState<ICmsDestination[]>(
    "destinationResponseAtom"
  );
  const [destinationsLoaded] = useRecState<boolean>("popularDestinationsLoadedAtom");

  const filteredDestinations = useMemo(() => {
    if (filterId) {
      return destinations.filter(
        (destination) => destination.documentId !== filterId
      );
    }
    return destinations;
  }, [destinations, filterId]);

  useOnLanguageChange(() => {
    _eventBus.emit({
      eventName: evtTree.Destinations.Get,
    });
  });

  if (!destinationsLoaded) {
    return <SectionCardSkeleton count={3} />;
  }

  return (
    <div className="popular-destination">
      <div>
        <CommonCardSlider
          key={filteredDestinations.toString()}
          title={title ? title : intl.formatMessage({ id: "destinations" })}
          items={filteredDestinations}
          slidesPerPage={3}
          subTitle={subtitle}
          noRecordText={intl.formatMessage({ id: "noDestinationAvailable" })}
          renderItem={(destination) => (
            <DestinationCard destination={destination} />
          )}
        />
      </div>
    </div>
  );
};

const DestinationCard = ({ destination }: { destination: ICmsDestination }) => {
  const intl = useIntl();

  
    const onDicoverClick = (slug: string) => {
      if (slug && slug != "") {
        _eventBus.emit({
          eventName: evtTree.Destinations.Discover.Click,
          data: { slug }
        });
      }
    }

  return (
    <div className="destination-card card-shadow">
      <div className="destination-img">
        <Image
          src={destination.image?.url}
          width={387}
          height={256}
          alt={destination.name}
        />
      </div>
      <div className="destination-cont">
        <h2>{destination.name}</h2>
        {/* <Link href={`/destinations/${destination.slug}`}> */}
          <button className="discover-btn"  onClick={() => { onDicoverClick(destination.slug) }}>
            {intl.formatMessage({
              id: "discover",
            })}
          </button>
        {/* </Link> */}
      </div>
    </div>
  );
};

export default PopularDestinationWidget;
